/* blackroll-linkfix.js
   Rewrites blackroll.com (and stray foreign-locale) links inside blog/article
   body content so every internal hyperlink stays on blackroll.gr, in the
   visitor's current language. External research citations are left untouched. */
(function () {
  var LOCALES = ['de','en','fr','es','it','nl','pt','pl','da','sv','no','fi','cs','eu','at','ch','uk'];
  var PRODUCT_SUBS = {
    'blackroll-booster': 'blackroll-booster-2-0',
    'blackroll-booster-head': 'blackroll-booster-2-0',
    'blackroll-posture': 'blackroll-new-posture',
    'blackroll-posture-2-0-pro': 'blackroll-new-posture'
  };
  var PRODUCT_TO_COLLECTION = {
    'blackroll-deep-releazer': '/collections/vibration',
    'blackroll-fascia-releazer': '/collections/vibration'
  };
  function root() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }
  function stripLocaleSegments(path) {
    var parts = path.split('/');
    while (parts.length > 1) {
      var seg = (parts[1] || '').toLowerCase();
      var base = seg.split('-')[0];
      if (LOCALES.indexOf(seg) !== -1 || LOCALES.indexOf(base) !== -1) parts.splice(1, 1);
      else break;
    }
    var p = parts.join('/');
    return p.charAt(0) === '/' ? p : '/' + p;
  }
  function mapPath(path) {
    if (/^\/(our-experts|experts)\//.test(path)) return { unwrap: true };
    var pm = path.match(/^\/products\/([a-z0-9\-]+)(.*)$/);
    if (pm) {
      var handle = pm[1], rest = pm[2] || '';
      if (PRODUCT_TO_COLLECTION[handle]) return { path: PRODUCT_TO_COLLECTION[handle] };
      if (PRODUCT_SUBS[handle]) return { path: '/products/' + PRODUCT_SUBS[handle] + rest };
      return { path: path };
    }
    if (/^\/exercises(\/|$)/.test(path)) return { path: '/blogs/exercises' };
    path = path.replace(/^\/(article|artikel)\//, '/blogs/stories/');
    path = path.replace(/^\/(routine|routines)\//, '/blogs/exercises/');
    path = path.replace(/^\/knowledge\//, '/blogs/stories/tagged/');
    return { path: path };
  }
  function rewriteHref(href) {
    if (!href) return { action: 'keep' };
    var h = href.trim();
    if (/^(#|mailto:|tel:|javascript:)/i.test(h)) return { action: 'keep' };
    var isCom = /^https?:\/\/(www\.)?blackroll\.com(\/|$)/i.test(h);
    var isRootRel = h.charAt(0) === '/';
    if (!isCom && !isRootRel) return { action: 'keep' };
    var path;
    if (isCom) { path = h.replace(/^https?:\/\/(www\.)?blackroll\.com/i, ''); if (path === '') path = '/'; }
    else path = h;
    var tail = '', qh = path.match(/[?#].*$/);
    if (qh) { tail = qh[0]; path = path.slice(0, path.length - tail.length); }
    path = stripLocaleSegments(path);
    var mapped = mapPath(path);
    if (mapped.unwrap) return { action: 'unwrap' };
    return { action: 'rewrite', href: root() + mapped.path + tail };
  }
  function run() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var links = main.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.closest('.br-article, .br-article__tools, .br-article__related')) continue;
      var res = rewriteHref(a.getAttribute('href'));
      if (res.action === 'rewrite') {
        a.setAttribute('href', res.href);
      } else if (res.action === 'unwrap') {
        var span = document.createElement('span');
        span.className = 'br-unwrapped';
        while (a.firstChild) span.appendChild(a.firstChild);
        a.parentNode.replaceChild(span, a);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
